import logoSvg from "@/assets/images/logo.svg";
import {
  Facebook,
  Instagram,
  Linkedin,
  Mail,
  MapPin,
  Phone,
  Twitter,
} from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-propertylk-darkblue text-white/90 mt-auto">
<div className="max-w-7xl mx-auto lg:max-w-none lg:mx-0 py-12 px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <Link to="/" className="flex items-center mb-4">
              <img
                src={logoSvg}
                alt="Commercial Property LK Logo"
                className="h-10 w-auto brightness-0 invert"
              />
            </Link>
            <p className="text-white/70 mb-4">
              Your trusted partner for commercial real estate in Colombo, Sri
              Lanka. Find, buy, sell, or lease premium properties.
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="text-white/70 hover:text-white transition-colors"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href="#"
                className="text-white/70 hover:text-white transition-colors"
              >
                <Twitter className="h-5 w-5" />
              </a>
              <a
                href="#"
                className="text-white/70 hover:text-white transition-colors"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href="#"
                className="text-white/70 hover:text-white transition-colors"
              >
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/properties?category=sale"
                  className="text-white/70 hover:text-white transition-colors"
                >
                  Properties for Sale
                </Link>
              </li>
              <li>
                <Link
                  to="/properties?category=rent"
                  className="text-white/70 hover:text-white transition-colors"
                >
                  Properties for Rent
                </Link>
              </li>
              <li>
                <Link
                  to="/properties?category=lease"
                  className="text-white/70 hover:text-white transition-colors"
                >
                  Properties for Lease
                </Link>
              </li>
              <li>
                <Link
                  to="/market-data"
                  className="text-white/70 hover:text-white transition-colors"
                >
                  Market Insights
                </Link>
              </li>
              <li>
                <Link
                  to="/property-pulse"
                  className="text-white/70 hover:text-white transition-colors"
                >
                  Property Pulse
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Resources</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/property-pulse/guides"
                  className="text-white/70 hover:text-white transition-colors"
                >
                  Property Guides
                </Link>
              </li>
              <li>
                <Link
                  to="/property-pulse/market-reports"
                  className="text-white/70 hover:text-white transition-colors"
                >
                  Market Reports
                </Link>
              </li>
              <li>
                <Link
                  to="/property-pulse/investment"
                  className="text-white/70 hover:text-white transition-colors"
                >
                  Investment Analysis
                </Link>
              </li>
              <li>
                <Link
                  to="/property-pulse/news"
                  className="text-white/70 hover:text-white transition-colors"
                >
                  Property News
                </Link>
              </li>
              <li>
                <Link
                  to="/property-pulse"
                  className="text-white/70 hover:text-white transition-colors"
                >
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <MapPin className="h-5 w-5 mr-2 text-white/70 mt-0.5" />
                <span className="text-white/70">
                  42 Galle Road, Colombo 03, Sri Lanka
                </span>
              </li>
              <li className="flex items-center">
                <Phone className="h-5 w-5 mr-2 text-white/70" />
                <a
                  href="tel:+94112345678"
                  className="text-white/70 hover:text-white transition-colors"
                >
                  +94 11 234 5678
                </a>
              </li>
              <li className="flex items-center">
                <Mail className="h-5 w-5 mr-2 text-white/70" />
                <a
                  href="mailto:info@commercialproperty.lk"
                  className="text-white/70 hover:text-white transition-colors"
                >
                  info@commercialproperty.lk
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-8 pt-8 text-center text-white/60">
          <p>
            &copy; {currentYear} Commercial Property LK. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
